import {
  type StackSiderViewType,
  useStackSiderView,
} from '@/providers/StackSiderViewProvider';
import { matchProjectDetailPath } from '@/utils/route-match';
import { URL_PATH } from '@/utils/route-path';
import { useEffect, useMemo } from 'react';
import { matchPath, useLocation } from 'react-router';

const SHOW_SIDER_PATHS: Record<StackSiderViewType, string[]> = {
  comment: [`/${URL_PATH.comment}`, `/${URL_PATH.projectDetail}`],
  workflow: [`/${URL_PATH.workflow}`, `/${URL_PATH.projectDetail}`],
};

export const useStackSiderClearWhenLocationChange = ({
  siderType,
}: {
  siderType: StackSiderViewType;
}) => {
  const location = useLocation();
  const { dispatch, state } = useStackSiderView();

  const closeSider = useMemo(() => {
    // 現在の仕様だと事業詳細の場合はどの場合も閉じないためハードコーディング
    const isProjectDetailPage = matchProjectDetailPath(location.pathname);
    // ブラウザバックなどの場合に同一のprojectIdであればサイダーを閉じない
    if (isProjectDetailPage) {
      const isMatchProjectId =
        state.target.type === 'project' &&
        state.target.projectId === isProjectDetailPage.params.projectId;
      return !isMatchProjectId;
    }

    const isMatch = SHOW_SIDER_PATHS[siderType].some((path) =>
      matchPath({ path }, location.pathname),
    );

    // 現在開いているサイダーがページ単位のサイダーと一致しているか確認
    const isCurrentSiderTypeActive =
      state.stack[state.stack.length - 1]?.siderType === siderType;

    // パスが一致しないか、現在のサイダータイプが異なる場合はサイダーを閉じる
    return !isMatch || !isCurrentSiderTypeActive;
  }, [location.pathname, siderType, state]);

  useEffect(() => {
    if (closeSider) {
      dispatch({ type: 'CLEAR' });
    }
  }, [dispatch, closeSider]);
};
